<!-- mettal-3\src\components\X282.vue -->
<template>
  <div class="view-402-item-1">
    <img
      class="image-49"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/---------------21@2x.png"
      alt="image"
    />
    <div class="view-442">
      <div class="x01-46 poppins-semi-bold-white-16px">{{ x01 }}</div>
      <img
        class="vector-311"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-600.svg"
        alt="Vector"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "X282",
  props: ["x01"],
};
</script>

<style>
.view-402-item-1 {
  background-color: var(--storm-dust-2);
  border-radius: 12px;
  height: 90px;
  position: relative;
  width: 300px;
}

.image-49 {
  height: 86px;
  left: 4px;
  position: absolute;
  top: 3px;
  width: 293px;
}

.view-442 {
  height: 72px;
  left: 25px;
  position: absolute;
  top: 10px;
  width: 245px;
}

.x01-46,
.x01-47 {
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
  width: 203px;
}

.vector-311 {
  height: 29.3%;
  left: 0;
  position: absolute;
  top: 5.56%;
  width: 10.2%;
}
</style>
